import React, { Component } from "react";
import { Link } from "react-router-dom";

class Whychooseus extends Component {
  render() {
    return (
      <div>
        {/* Horizontal Line */}
        <hr style={{ borderTop: "2px solid #D18237", marginTop: "10px" }} />

        {/* Text and Button Content */}
        <div className="row mt-4">
          <div className="col-sm-6">
            <ul className="list-unstyled">
              <li className="mb-2">
                <i
                  className="bi bi-check2 me-2"
                  style={{ color: "#111E26", fontSize: "23px" }}
                ></i>
                Strong Commitment to Service
              </li>
              <li className="mb-2">
                <i
                  className="bi bi-check2 me-2"
                  style={{ color: "#111E26", fontSize: "23px" }}
                ></i>
                Continuous Employment and Security of Tenure
              </li>
              <li>
                <i
                  className="bi bi-check2 me-2"
                  style={{ color: "#111E26", fontSize: "23px" }}
                ></i>
                We provide the best Care for our People
              </li>
            </ul>
          </div>

          <div className="col-sm-6 d-flex justify-content-between align-items-start mt-4">
            <p className="mb-0 me-4">
              We are the <b>Leading Provider</b> of Skilled Personnel
              specializing in Hotel and Restaurant Industry.
            </p>

            {/* Apply Button & Arrow - Positioned at the upper right */}
            <div
              className="position-relative rounded-pill mt-2"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                backgroundColor: "#111E26",
                width: "100%",
                maxWidth: "160px",
                padding: "2.5px",
                boxSizing: "border-box",
              }}
            >
              <Link
                to={"/clientpage"}
                style={{ display: "flex", alignItems: "center" }}
              >
                <button
                  className="apply-btn"
                  style={{
                    padding: "10.5px 14px",
                    borderRadius: "50px",
                    backgroundColor: "#111E26",
                    color: "white",
                    border: "none",
                    fontSize: "0.899rem",
                    fontWeight: "normal",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginLeft: "5px",
                  }}
                >
                  Know more
                </button>

                <button
                  className="arrow-btn"
                  style={{
                    width: "31px",
                    height: "31px",
                    marginLeft: "2.5px",
                    backgroundColor: "#D18237",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "none",
                    color: "white",
                    fontSize: "1rem",
                  }}
                >
                  <i className="bi bi-arrow-up-right"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="row mt-4 justify-content-center gap-4 mb-5">
          <div className="col-md-5 mb-3">
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src="/Bar.jpg"
              className="img-fluid rounded"
              alt="Kitchen Staff"
            />
          </div>
          <div className="col-md-5 mb-3">
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src="/FrontDesk.jpg"
              className="img-fluid rounded"
              alt="Waiters"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Whychooseus;
